// src/components/settings/sections/IntegrationsSettings.js
import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const IntegrationsSettings = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-semibold text-gray-800">Integrations</h2>
            <p className="text-gray-600">Connect LocalRewards with your other business tools like POS systems and e-commerce platforms.</p>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center text-gray-500">
                <InformationCircleIcon className="h-10 w-10 mx-auto mb-3 text-gray-400" />
                <p className="text-lg font-medium">Integrations coming soon!</p>
                <p className="text-sm mt-2">We're working on seamless connections with popular platforms. Check back here for updates.</p>
            </div>
        </div>
    );
};

export default IntegrationsSettings;